// LWI-1593 — handling unit weight UOM. The list is the Shipment Management
// "Weight UOM" field (weight_uom: LB, KG); the generic Units of Measurement
// list (Gram, Each, Gallon…) was wrongly used before and those values went to
// MercuryGate verbatim. Totals are shown in pounds, so KG units convert.
// LWI-1769 — Lima also records units in OZ, FT, IN, EA and GA. OZ converts to
// pounds; FT / IN / EA / GA are not weights, so their figure counts as pounds
// (as a blank UOM always has), matching the backend's MsrWeightUom.

export const WEIGHT_UOMS = ["LB", "KG", "OZ", "FT", "IN", "EA", "GA"];
export const DEFAULT_WEIGHT_UOM = "LB";
export const LB_PER_KG = 2.20462;
export const LB_PER_OZ = 0.0625;

const LABELS = {
  LB: "Pounds (LB)",
  KG: "Kilograms (KG)",
  OZ: "Ounces (OZ)",
  FT: "Feet (FT)",
  IN: "Inches (IN)",
  EA: "Each (EA)",
  GA: "Gallons (GA)",
};

const ALIASES = {
  lb: "LB",
  lbs: "LB",
  pound: "LB",
  pounds: "LB",
  kg: "KG",
  kgs: "KG",
  kilo: "KG",
  kilos: "KG",
  kilogram: "KG",
  kilograms: "KG",
  oz: "OZ",
  ounce: "OZ",
  ounces: "OZ",
  ft: "FT",
  foot: "FT",
  feet: "FT",
  in: "IN",
  inch: "IN",
  inches: "IN",
  ea: "EA",
  each: "EA",
  ga: "GA",
  gal: "GA",
  gallon: "GA",
  gallons: "GA",
};

/** "lbs" → "LB", "kg" → "KG"; anything else comes back trimmed and unchanged. */
export const normalizeWeightUom = (value) => {
  const raw = String(value ?? "").trim();
  return ALIASES[raw.toLowerCase()] ?? raw;
};

/** True for a value that is set but isn't an accepted unit (a leftover "Gram"…). */
export const isInvalidWeightUom = (value) => {
  const v = normalizeWeightUom(value);
  return v !== "" && !WEIGHT_UOMS.includes(v);
};

export const weightUomLabel = (value) => {
  const v = normalizeWeightUom(value);
  return LABELS[v] ?? v;
};

/**
 * LWI-1769 — the select options are the accepted units themselves
 * (App\Support\MsrWeightUom::ALLOWED). The Shipment Management "Weight UOM"
 * dropdown list is shared with the CCI invoice footer, which takes LB / KG
 * only, so Pick and Pack no longer reads it.
 */
export const WEIGHT_UOM_OPTIONS = WEIGHT_UOMS.map((v) => ({
  value: v,
  name: weightUomLabel(v),
}));

/** A unit weight in pounds; KG and OZ convert, any other UOM is taken as pounds. */
export const toPounds = (weight, uom) => {
  const w = parseFloat(weight) || 0;
  const u = normalizeWeightUom(uom);
  if (u === "KG") return w * LB_PER_KG;
  if (u === "OZ") return w * LB_PER_OZ;
  return w;
};
